import React, { Component } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { CaseManagementStore, CommonStore } from "Store";
import Header from "./header/HeaderWithStoreMutation";
import MessageList from "./message-list/MessageListWithStoreQuery";
import ApprovalList from "./approval-list/ApprovalList";
import Footer from "./footer/FooterWithStoreMutation";
import ApprovalFooter from "./footer/ApprovalFooterWithStoreMutation";
import EmptyPanel from "./EmptyPanel";

// this component is responsible for showing content panel
// (header, message, pending message, input reply)
export default observer(
  class ContentPanel extends Component {
    render() {
      const store = CaseManagementStore;
      const { selectedCase, selectedTab, editPending } = store;

      // show footer except on pending tab
      let footerRender;
      if (selectedTab !== "pending") {
        if (editPending.id === -1) {
          footerRender = <Footer />;
        } else {
          footerRender = <ApprovalFooter />;
        }
      }

      // check if user selected open case
      const showingContentPanel =
        selectedCase && selectedCase.progressType === "OPEN";

      if (showingContentPanel) {
        // if user selected case, show content
        const caseId = selectedCase.id;
        return (
          <Content>
            <Header />
            <MessageList
              key={"MessageList-" + caseId}
              case={{ id: caseId }}
              store={store}
            />
            <ApprovalList
              key={"ApprovalList-" + caseId}
              pendingStreams={selectedCase.pendingStreams.toJS()}
              agentId={CommonStore.me.agent.id}
            />
            {footerRender}
          </Content>
        );
      } else {
        // if no selected case, show empty screen
        return (
          <Content>
            <EmptyPanel />
          </Content>
        );
      }
    }
  }
);

const Content = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/ContentPanelWithStore.js